import { Link } from 'react-router-dom';
import { Briefcase, Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { BRAND_LOGO_URL } from './constants';

export const LandingNav = () => (
  <nav className="sticky top-0 z-50 border-b border-border/50 bg-card/90 backdrop-blur-sm">
    <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <img src={BRAND_LOGO_URL} alt="Icarus D&D" className="h-9 w-9 rounded-full object-cover" />
        <span className="flex items-baseline gap-1.5">
          <span className="font-serif text-lg font-semibold tracking-[-0.01em] text-ink">Icarus</span>
          <span className="font-mono text-[11px] font-semibold tracking-[0.14em] text-ink-tertiary-2">D&D</span>
        </span>
        <a
          href="https://www.icarus-nutrition.de"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:inline-flex items-center text-xs text-muted-foreground hover:text-primary transition-colors border-l border-border/50 pl-3"
        >
          by Icarus Health
        </a>
      </div>
      <div className="flex items-center gap-3">
        <Link to="/praxis" className="hidden md:block">
          <Button variant="ghost" size="sm" className="text-sm font-medium text-gray-700 hover:text-gray-900">
            <Briefcase className="w-3 h-3 mr-1" />
            Für Praxen
          </Button>
        </Link>
        <a href="#preise">
          <Button variant="ghost" size="sm" className="text-sm font-medium text-gray-700 hover:text-gray-900">
            Preise
          </Button>
        </a>
        <Link to="/login">
          <Button variant="ghost" size="sm" className="text-sm font-medium text-amber-700 hover:text-amber-800">
            <Play className="w-3 h-3 mr-1" />
            Demo
          </Button>
        </Link>
        <Link to="/login">
          <Button size="sm" className="bg-primary hover:bg-primary/90 text-white rounded-xl text-sm font-semibold">
            Login
          </Button>
        </Link>
      </div>
    </div>
  </nav>
);
